/* ec-sec-static-collection.js — script externalized from sections/static-collection.liquid (Liquid values arrive via window.ECSQ bootstrap) */
(function() {
  if (window.__ecAsset_staticCollection) return;
  window.__ecAsset_staticCollection = 1;

  var ecConfigs = {};

  function initSection(sectionId, cfg) {
    cfg = cfg || {};

    /* Grid column toggle */
    var gridToggle = document.querySelector('[data-coll-grid="' + sectionId + '"]');
    var collGrid = document.querySelector('#shopify-section-' + sectionId + ' .ec-coll-grid');
    if (gridToggle && collGrid) {
      function ecSetCols(cols, btn) {
        collGrid.style.setProperty('--ec-coll-cols', cols);
        gridToggle.querySelectorAll('[data-cols]').forEach(function(b){ b.classList.toggle('is-active', b === btn); });
      }
      gridToggle.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-cols]');
        if (!btn) return;
        var cols = btn.getAttribute('data-cols');
        ecSetCols(cols, btn);
        try { localStorage.setItem('ecCollCols', cols); } catch(err) {}
      });
      try {
        var saved = localStorage.getItem('ecCollCols');
        if (saved && window.innerWidth > 989) {
          var sb = gridToggle.querySelector('[data-cols="' + saved + '"]');
          if (sb) ecSetCols(saved, sb);
        }
      } catch(err) {}
    }

    /* Mobile filter toggle */
    var filterToggle = document.getElementById('ec-filtertoggle-' + sectionId);
    var sidebar = document.getElementById('ec-coll-sidebar-' + sectionId);
    if (filterToggle && sidebar) {
      filterToggle.addEventListener('click', function() {
        var open = sidebar.classList.toggle('is-open');
        filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* Sort select */
    var sortSelect = document.getElementById('ec-sort-' + sectionId);
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var u = new URL(window.location);
        u.searchParams.set('sort_by', sortSelect.value);
        window.location = u.toString();
      });
    }

    /* Filter checkboxes — URL-merge: form.submit() sort_by/pill parametrelerini siliyordu */
    var filterForm = document.getElementById('ecFilterForm-' + sectionId);
    if (filterForm) {
      var applyFilters = function() {
        var u = new URL(window.location.href);
        var names = {};
        filterForm.querySelectorAll('[name]').forEach(function(el) { names[el.name] = 1; });
        Object.keys(names).forEach(function(n) { u.searchParams.delete(n); });
        new FormData(filterForm).forEach(function(v, k) {
          if (v !== '') u.searchParams.append(k, v);
        });
        u.searchParams.delete('page');
        window.location.assign(u.toString());
      };
      var checkboxes = filterForm.querySelectorAll('.ec-filter-checkbox');
      checkboxes.forEach(function(cb) {
        cb.addEventListener('change', applyFilters);
      });
      filterForm.addEventListener('submit', function(e) { e.preventDefault(); applyFilters(); });
    }

    /* Load more */
    var btn = document.getElementById('ec-loadmore-' + sectionId);
    if (!btn) return;

    btn.addEventListener('click', function() {
      var url = btn.dataset.next;
      if (!url) return;
      btn.classList.add('is-loading');
      btn.textContent = cfg.loading + '...';

      fetch(url).then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); }).then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newItems = doc.querySelectorAll('.ec-coll-grid .ec-prod-card');
        var grid = document.querySelector('.ec-coll-grid');

        newItems.forEach(function(item) {
          grid.appendChild(item);
        });

        var newBtn = doc.querySelector('[id^="ec-loadmore-"]');
        if (newBtn) {
          btn.dataset.next = newBtn.dataset.next;
          btn.classList.remove('is-loading');
          btn.textContent = cfg.loadMore;
        } else {
          btn.remove();
        }

        var progress = document.querySelector('.ec-coll-progress');
        var newProgress = doc.querySelector('.ec-coll-progress');
        if (progress && newProgress) {
          progress.textContent = newProgress.textContent;
        }
      }).catch(function() {
        btn.classList.remove('is-loading');
        btn.textContent = cfg.loadMore;
      });
    });
  }

  /* Drain queued bootstraps for this asset; returns section ids initialized in this pass */
  function ecDrainQueue() {
    var q = window.ECSQ || [];
    var mine = [];
    var rest = [];
    var i;
    for (i = 0; i < q.length; i++) {
      if (q[i] && q[i][0] === 'static-collection') { mine.push(q[i]); } else { rest.push(q[i]); }
    }
    window.ECSQ = rest;
    var ids = [];
    for (i = 0; i < mine.length; i++) {
      ecConfigs[mine[i][1]] = mine[i][2];
      initSection(mine[i][1], mine[i][2]);
      ids.push(mine[i][1]);
    }
    return ids;
  }

  if (document.readyState !== 'loading') {
    ecDrainQueue();
  } else {
    document.addEventListener('DOMContentLoaded', ecDrainQueue);
  }

  /* Theme editor: re-init on section re-render (fresh bootstrap push wins; fall back to stored config) */
  document.addEventListener('shopify:section:load', function(e) {
    var id = e.detail && e.detail.sectionId;
    var drained = ecDrainQueue();
    if (id && ecConfigs[id] && drained.indexOf(id) === -1) {
      initSection(id, ecConfigs[id]);
    }
  });
})();
